var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 19 22",
    fill: "#F5F6FA",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.061 6.338c0-.965.783-1.748 1.748-1.748h10.682c.966 0 1.749.783 1.749 1.748v13.208c0 .965-.783 1.748-1.748 1.748H5.808a1.748 1.748 0 0 1-1.748-1.748V6.338Zm1.942.195v12.819h10.294V6.532H6.003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.176 1.774c0-.59.479-1.068 1.069-1.068h12.042v2.136H2.313v12.916H.176V1.774Z"
  })));
};

export default SvgCopy;